import axios from 'axios';

export const formBuilderService = {
  /**
   * Form kaydetme işlemi
   */
  async saveForm(formData, appToken, userData) {
    try {
      const newFormId = formData.formId || `form_${Math.floor(Math.random() * 1000000000000)}`;
      
      // PDF alanlarını tespit et
      const pdfFields = formData.formFields.filter(field => 
        (field.type === 'pdf' || field.type === 'pdfDocument') && 
        field.uploadedFiles && 
        field.uploadedFiles.length > 0
      );
      
      console.log('PDF alanları tespit edildi:', pdfFields.length);
      if (pdfFields.length > 0) {
        console.log('PDF alanları:', pdfFields);
      }
      
      // Form içeriği objesi
      const formContentObj = {
        id: newFormId,
        title: formData.formTitle || '',
        description: formData.formDescription || '',
        fields: formData.formFields.map(field => {
          if (field.type === 'calculation') {
            return {
              ...field,
              calculationData: formData.calculationValues[field.id] || {}
            };
          }
          return field;
        }),
        settings: {
          ...formData.formSettings,
          documentControlEnabled: formData.formSettings.documentControlEnabled || false,
          documentPrefix: formData.formSettings.documentPrefix || 'DOK',
          documentCode: formData.formSettings.documentCode || '001',
          department: formData.formSettings.department || '',
          backgroundColor: formData.formSettings.backgroundColor || '#ffffff',
          titleColor: formData.formSettings.titleColor || '#000000',
          descriptionColor: formData.formSettings.descriptionColor || '#666666',
          submitButtonColor: formData.formSettings.submitButtonColor || '#1976d2',
          submitButtonTextColor: formData.formSettings.submitButtonTextColor || '#ffffff',
          fieldSize: formData.formSettings.fieldSize || 'medium',
          formWidth: formData.formSettings.formWidth || 'medium',
          submitButtonText: formData.formSettings.submitButtonText || 'Gönder',
          fontFamily: formData.formSettings.fontFamily || 'Roboto',
          fontSize: formData.formSettings.fontSize || 'medium',
          fieldBorderRadius: formData.formSettings.fieldBorderRadius || '4px',
          fieldBorderColor: formData.formSettings.fieldBorderColor || '#e0e0e0',
          fieldBackgroundColor: formData.formSettings.fieldBackgroundColor || '#ffffff',
          fieldFocusColor: formData.formSettings.fieldFocusColor || '#1976d2',
          animationEnabled: formData.formSettings.animationEnabled || false,
          animationType: formData.formSettings.animationType || 'fade',
          accessibilityEnabled: formData.formSettings.accessibilityEnabled || false,
          highContrastMode: formData.formSettings.highContrastMode || false,
          securityEnabled: formData.formSettings.securityEnabled || false,
          captchaEnabled: formData.formSettings.captchaEnabled || false,
          maxSubmissions: formData.formSettings.maxSubmissions || 1000
        },
        isPublished: true,
        publishedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        formLink: formData.formLink,
        logo: userData?.logoUrl,
      };

      console.log('📝 Kaydedilecek form ayarları:', formContentObj.settings);

      // API'ye gönderilecek içerik
      const content = {
        parentId: formData.selectedFolderIds.join(','),
        formId: newFormId,
        title: formData.formTitle,
        formContent: formContentObj,
        isActive: true,
        fileType: 0,
        documentPrefix: formData.formSettings.documentPrefix || '',
        documentCode: formData.formSettings.documentCode || '',
        department: formData.formSettings.department || ''
      };

      const response = await axios.post('https://app.hhoms.com/api/form/Libraries', content, {
        headers: {
          'Content-Type': 'application/json',
          ApplicationToken: appToken,
          User: userData.id,
        },
      });

      if (response.status === 200) {
        // PDF alanları varsa PDF endpoint'ini de çağır
        if (pdfFields.length > 0) {
          await this.handlePdfUploads(pdfFields, appToken, userData);
        }
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data?.message || 'Form kaydedilemedi');
      }
    } catch (error) {
      console.error('Form kaydedilirken hata oluştu:', error);
      throw this.handleApiError(error);
    }
  },

  /**
   * PDF dosyalarını yükleme işlemi
   */
  async handlePdfUploads(pdfFields, appToken, userData) {
    try {
      // PDF upload fonksiyonu
      const uploadPdfFunc = (file) => {
        var bodyForm = new FormData();
        bodyForm.append("File", file);
        return axios.post("https://app.hhoms.com/api/panel/pdf", bodyForm, {
          headers: { ApplicationToken: appToken, User: userData.id },
        });
      };

      // Her PDF dosyası için ayrı ayrı işlem yap
      for (const field of pdfFields) {
        for (const file of field.uploadedFiles) {
          // Base64'ü blob'a çevir
          const base64Data = file.base64.split(',')[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: file.type });
          
          // Dosyayı upload et
          const uploadResponse = await uploadPdfFunc(blob);
          
          console.log('PDF upload response:', uploadResponse.data);
          console.log('PDF upload status:', uploadResponse.status);
          
          // Server'dan dönen URL'i kontrol et
          let pdfUrl = null;
          
          if (uploadResponse.data) {
            if (uploadResponse.data.pdf) {
              pdfUrl = uploadResponse.data.pdf;
            } else if (uploadResponse.data.url) {
              pdfUrl = uploadResponse.data.url;
            } else if (uploadResponse.data.Url) {
              pdfUrl = uploadResponse.data.Url;
            } else if (typeof uploadResponse.data === 'string') {
              pdfUrl = uploadResponse.data;
            }
          }
          
          console.log('Extracted PDF URL:', pdfUrl);
          
          if (pdfUrl) {
            // URL'i form field'ına da kaydet
            field.pdfUrl = pdfUrl;
          } else {
            console.error('Server PDF URL döndürmedi!');
            console.error('Server response:', uploadResponse.data);
            throw new Error('PDF yüklenemedi - Server URL döndürmedi');
          }
        }
      }
    } catch (error) {
      console.error('PDF upload error:', error);
      throw new Error('PDF dosyaları yüklenirken hata oluştu: ' + error.message);
    }
  },

  /**
   * Klasörleri getirme işlemi
   */
  async fetchFolders(appToken, userData) {
    try {
      const response = await axios.get("https://app.hhoms.com/api/form/Categories/parent/list", {
        headers: { ApplicationToken: appToken, User: userData.id }
      });
      
      console.log("Klasörler:", response.data.formCategories);
      return {
        folders: response.data.formCategories || [],
        formCategories: response.data
      };
    } catch (error) {
      console.error("Klasörler yüklenirken hata:", error);
      throw new Error('Klasörler yüklenirken hata oluştu');
    }
  },

  /**
   * API hatalarını işleme
   */
  handleApiError(error) {
    let errorMessage = 'Beklenmeyen bir hata oluştu.';
    
    if (error.response) {
      // Sunucudan gelen hata mesajı
      errorMessage = error.response.data?.message || error.response.data?.error || 'Sunucu hatası oluştu.';
    } else if (error.request) {
      // İstek yapıldı ama yanıt alınamadı
      errorMessage = 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.';
    } else {
      // İstek oluşturulurken hata oluştu
      errorMessage = error.message || 'Beklenmeyen bir hata oluştu.';
    }

    return new Error(errorMessage);
  }
};
